// General use
export const DateFormatDatePicker = {  parse: {    dateInput: "DD/MM/YYYY",  },  display: {    dateInput: 'DD/MM/YYYY',    monthYearLabel: 'MMM YYYY',    dateA11yLabel: 'L',    monthYearA11yLabel: 'MMMM-YYYY',  }}
export const jsonheader = { 'content-type': 'application/json' };

// Events
export const EVENTTYP_INSERT = 1;   // Global events
export const EVENTTYP_UPDATE = 2;
export const EVENTTYP_DELETE = 3;
export const EVENTTYP_PRINT = 4;

export const OBJECTTYP_USER = 8;				// c_user
export const OBJECTTYP_HCCARD = 10;     // Health Care Card
export const OBJECTTYP_HCORDER = 11;    // Health Care order (fse_order)
export const OBJECTTYP_HCPATIENT = 13;  // Health Care Patient
export const OBJECTTYP_HCBATCH = 14;    // Health Care Batch (fse_batch)
export const OBJECTTYP_HCDOC = 16;    	// Health Care Doc (fse_doc)
export const OBJECTTYP_STATION = 17;    // C_STATION

export const EVENTTYP_FSE_UPDATESPECIF = 301;
export const EVENTTYP_FSE_UPDATEORDERDATA = 302;  // Update fse_order.data.HTTPResponse
export const EVENTTYP_FSE_UPDATEIDPJ = 303;     	// Update fse_doc.idpj based on ajouterPJ
export const EVENTTYP_FSE_UPDATEMODEADRI = 304;  	// Update c_station.data.mode_appel_adri
export const EVENTTYP_FSE_UPDATEUSERDATA = 305; 	// Update c_user.data
export const EVENTTYP_FSE_UPDATEORDERSTATE = 306	// Update fse_doc.etat_facture

// FSE Modes
export const MODE_FSE_CV = 0;
export const MODE_FSE_APCV_QR = 1;
export const MODE_FSE_APCV_NFC = 2;
export const MODE_FSE_DEGRADE = 3;

// Situations spécifiques
export const C2S_AMO = '01';							// C2S géréepar l’AMO
export const C2S_AMC_CONV = '02';				  // C2S géré par un AMC en convention de gestion ou en délégation de gestion
// WARNING Area ne distingue pas les 2 cas suivants :
export const C2S_AMC_DIRECT = '03';			  // C2S gérée par une AMC, transmission directe possible
export const C2S_AMC_ATT = '03';					// C2S gérée par une AMC, transmission directe possible, attestation compl. éventuelle
export const C2S_SORTANT = '10';					// Sortant de complémentaire santé solidaire
// export const AME = 5;									// AME Area ?

export const MIGRANT_AUTRE = '70';				// codeGest "autre situation de migrant"
export const VICTIME_ATTENTAT = '13';		  // codeGest "victime d'attentat" Article L.115 victime de guerre

// Used in SituationNature.msgu
// Voir <codeSrvAMOBenef>. Code situation lu en carte et 	<codeServiceAMO> de facturer 
export const sitspecsmsg: {[key: string]: string} = {
	'00': "",																																									// Le bénéficiaire n'a pas de service AMO spécifique => no lib
	'01': "Complémentaire santé solidaire gérée par le régime obligatoire",
	'02': "Complémentaire santé solidaire par AMC conv. ou AMO",
	'03': "Complémentaire santé solidaire par AMC",
	'10': "Sortant de Complémentaire santé solidaire",
	'11': "Bénéficiaire du dispositif d'aide à l'acquisition d'une complémentaire",
	'12': "Bénéficiaire ACS Contrat A",	
	'13': "Bénéficiaire ACS Contrat B",
	'14': "Bénéficiaire ACS Contrat C",
}

// Voir <typeAttestationParticuliere> de facturer.beneficiaire.attestationAMC
// Déduit de codeSrvAMOBenef (?) R: NON! A special listbox exists in pieceJustifAMC = 'Autre que la cv'
/*
export const 	typeAttestationParticuliere	: {[key: string]: string} = {
	'00': "AUCUNE",																																							
	'01': "CMU_C",
	'02': "CMU_C",
	'03': "CMU_C",
	'10': "SORTANT_CMU",
	'12': "ACS_A",	
	'13': "ACS_A",
	'14': "ACS_A",
}
*/

export const codeRegime: { [key: string]: string } = {	// Not used for now
  '01': "Régime général",
  '02': "Régime agricole",
  '03': "Régime des Salariés Indépendants - RSI",
  '04': "Caisse de Prévoyance et de Retraite de la SNCF - CPR SNCF",
  '05': "Régime Spécial de la Régie Autonome des Transports Parisiens - RATP",
  '06': "Etablissement National des Invalides de la Marine - ENIM",
  '07': "Régime minier de Sécurité Sociale",
  '08': "Caisse Nationale Militaire de Sécurité Sociale - CNMSS",
  '09': "Caisse de Prévoyance Maladie de la Banque de France - CPM Banque de France",
  '10': "Caisse de Retraite et de Prévoyance des Clercs et Employés de Notaire - CRPCEN",
  '12': "Chambre de Commerce et d'Industrie de Paris - CCIP",
  '14': "Fonds de sécurité sociale de l'Assemblée Nationale",
  '15': "Caisses autonomes de Sécurité Sociale du Sénat",
  '16': "Caisse de Prévoyance du Personnel titulaire du Port Autonome de Bordeaux",
  '17': "Caisse des français à l'étranger",
  '80': "Ministère des anciens combattants (ces régimes ne sont pas gérés par la carte Vitale)",
  '90': "Caisse d'Assurance Vieillesse, Invalidité et Maladie des Cultes - CAVIMAC",
  '91': "Mutuelle Générale de l'Education Nationale - MGEN",
  '92': "Mutuelle Générale des PTT - MGPTT",
  '93': "Mutuelle Générale de la police - MGP",
  '94': "Mutualité de la Fonction Publique - MFP",
  '95': "Mutuelle Nationale des Hospitaliers - MNH",
  '96': "Mutuelle Nationale Aviation Marine - MNAM",
  '99': "Autres mutuelles",
};

export const TYP_PJ_AMO_CV = 0;		// Type PJ AMO == Support de droit principal (AMO = origine du beneficiaire)
export const TYP_PJ_AMO_ADR = 1;